exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".log-dialog[data-v-744f1851] .el-dialog__body{padding-top:10px;padding-bottom:10px;max-height:calc(100vh - 280px);overflow-y:auto}.log-dialog[data-v-744f1851] .el-dialog__body .height-block{min-height:344px;max-height:calc(100vh - 420px);overflow-y:auto}\n", ""]);

// exports
